<template>
  <v-btn @click="exportxlsx" color="grey" outline>
    <i class="fas fa-file-export"></i>
    &nbsp;
    {{ $t('export') }}&nbsp;
  </v-btn>
</template>

<script>
import XLSX from 'xlsx'
export default {
  props: {
    value: {
      type: Array,
      default: [],
      require: true,
    },
    filename: {
      type: String,
      default: 'exportedfile',
    },
  },
  methods: {
    async exportxlsx() {
      var json = this.value

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, this.filename + '.xlsx')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/exportxlsx.vue